import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIBadge from 'UIComponents/badge/UIBadge';
import Big from 'UIComponents/elements/Big';
import Small from 'UIComponents/elements/Small';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import { Flex } from 'foundations-components/components/Flex';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import InstallCount from '../../common/components/InstallCount';
import { getAppCategoryI18nKey } from '../../common/utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MAX_ICON_WIDTH = 48;
export default function AppSearchBarResult({
  category,
  categoryV2,
  companyName,
  firstPublishedAt,
  iconUrl,
  installsCount,
  isMobileView,
  isUngatedForRecommendationsBadge,
  isUngatedForSearchbarUpdates,
  name,
  recommended,
  tagline
}) {
  return /*#__PURE__*/_jsxs(UIMediaObject, {
    itemLeft: /*#__PURE__*/_jsx("div", {
      style: {
        width: MAX_ICON_WIDTH
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: iconUrl,
        role: "presentation"
      })
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      "data-selenium-id": `${name}-typeahead-search-result`,
      className: "m-bottom-1",
      children: [recommended && isUngatedForRecommendationsBadge ? /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx(Big, {
          className: "display-block",
          children: /*#__PURE__*/_jsx("b", {
            children: name
          })
        }), /*#__PURE__*/_jsx(UIBadge, {
          className: "m-left-2",
          use: "thunderdome",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-apps-core.appSearchBarResult.recommended"
          })
        })]
      }) : /*#__PURE__*/_jsx(Big, {
        className: "display-block",
        children: /*#__PURE__*/_jsx("b", {
          children: name
        })
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: isUngatedForSearchbarUpdates ? /*#__PURE__*/_jsxs(Flex, {
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-apps-core.appSearchBarResult.companyName",
            options: {
              companyName
            }
          }), /*#__PURE__*/_jsx(InstallCount, {
            firstPublishedAt: firstPublishedAt,
            installsCount: installsCount
          }), /*#__PURE__*/_jsx(FormattedList, {
            children: categoryV2.map((value, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
              message: getAppCategoryI18nKey(value)
            }, `${index}-${value}`))
          })]
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.appSearchBarResult.companyName",
          options: {
            companyName
          }
        })
      })]
    }), !isUngatedForSearchbarUpdates && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(UITruncateMultiline, {
          maxChars: 55,
          text: tagline,
          style: {
            whiteSpace: 'pre-wrap'
          },
          tagName: "div"
        })
      }), !isMobileView && /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.appSearchBarResult.inCategory",
          options: {
            category: unescapedText(getCategoryI18nKey(category))
          }
        })
      })]
    })]
  });
}